import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useSearchMappingProfile = branchGuid => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const { enqueueSnackbar } = useSnackbar();

  const searchMapping = (profileGuid, searchTerm, cb) => {
    setLoading(true);
    axiosClient
      .get(`SettingProduct/MappingIndex/Search`, {
        params: {
          mappingProfile: profileGuid,
          SearchTerm: searchTerm,
        },
      })
      .then(res => {
        if (res.status === 200) {
          setData(res.data.value);
          if (cb) {
            cb(res.data.value);
          }
        } else {
          enqueueSnackbar(res.data?.message, { variant: 'error' });
        }
      })
      .catch(err => enqueueSnackbar(err?.message, { variant: 'error' }))
      .finally(() => setLoading(false));
  };

  return [searchMapping, loading, data];
};

export default useSearchMappingProfile;
